<template>
  <v-card width="100%">
    <div class="barometer-wrapper">
      <div class="barometer-header">
        <h2>Productverkoop t.o.v. omzet</h2>
        <h3 v-if="selectedDataView == 'months'">
          <span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths"> {{ month.name }}</span>
          </span>
        </h3>
        <h3
          v-if="selectedDataView == 'fourweeks'"
        >week {{(selectedDataFourWeeks * 4) - 3 }} t/m {{(selectedDataFourWeeks * 4)}}</h3>
        <h3 v-if="selectedDataView == 'weeks'">week {{ selectedDataWeek }}</h3>
      </div>
      <div class="barometer-canvas-wrapper">
        <canvas :id="canvasID" generateGradient="false" width="210" height="140" ></canvas>
      </div>

      <div v-if="target"  class="barometer-footer">
        <p class="barometer-rate ma-0"><span v-if="rate > targetPercentage" class="on-fire"></span> {{rate.toFixed(1)}}%</p>
        <p class="barometer-description">Doelstelling is om <b>{{targetPercentage}}%</b> t.o.v. de omzet te halen</p>
      </div>

      <div v-else class="barometer-footer">
        <p class="barometer-rate ma-0">0%</p>
        <div class="barometer-alert">
          <v-alert 
            :value="true"
            type="warning"
          >
            Er is nog geen doel ingesteld.
          </v-alert>
         </div>
      </div>
      
    </div>
  </v-card>
</template>

<script>
import { bus } from "../../main";
export default {
  props: ["level", "marks", "aperture", "targetPercentage", "colorStart", "colorStop", "canvasID", "rate", "target", "weeknr",
    "selectedDataView",
    "selectedDataWeek",
    "selectedDataMonths",
    "selectedDataFourWeeks",
    "months"],
  name: "gaugeProductRevenue",

  data: () => ({
    mini: true,
    id: null, //passed getal door
    canvasRender: null,

    opts: {
      angle: -0.1, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676"
      },

      strokeColor: "rgb(204,204,204)",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      // generateGradient: true,
      highDpiSupport: true,

      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],
      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0 // Optional: Numerical precision. 0=round off.
      }
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    }
  }),

  created() {
    bus.$on("salonBarometerUpdate", this.updateData);
    if(this.colorStop && this.colorStart){
      this.opts.colorStop = this.colorStop;
      this.opts.colorStart = this.colorStart;
    } 
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
      // var opts = this.opts;
      if(this.rate <= 25){
        this.opts.colorStop = "#ff0a0a";
        this.opts.colorStart = "#ff0a0a";
      }
      else if(this.rate <= 50 && this.rate > 25 ){
        this.opts.colorStop = "#f2ce02";
        this.opts.colorStart = "#f2ce02";
      }
      else if(this.rate <= 75 && this.rate > 50 ){
        this.opts.colorStop = "#ebff0a";
        this.opts.colorStart = "#ebff0a";
      }
      else if(this.rate <= 100 && this.rate > 75 ){
        this.opts.colorStop = "#85e62c";
        this.opts.colorStart = "#85e62c";
      }
      else if(this.rate > 100){
        this.opts.colorStop = "#209c05";
        this.opts.colorStart = "#209c05";
      }
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(this.opts); // Unieke Gauge opbouwn
      gauge.maxValue = 120; // max gauge value
      gauge.setMinValue(0); // min value
      gauge.set(this.rate); // actual value

      // setInterval(() => {
      //   this.triggerme();
      // }, 3000);
    }
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    }
  }
};
</script>
